import React, { CSSProperties } from "react";
import Layout from "../../Layout";
import CatalogsLayout from "Components/CatalogsLayout";
import Grid, { TextFilter } from "Components/Grid";
import Buttons from "../../Components/Buttons";
import { useSelector } from "react-redux";
import { create, update, get, permissions } from "actions/user";
import { getProfiles } from "actions/perfil";
import {
  getOperationTypesByMarca,
  getOperacionFindForPerfilId,
  operacionFindByUsuario,
} from "actions/tipoOperacion";
import { getByPerfil, getFindUsuarioVista } from "actions/vista";
import { getBrands } from "actions/marca";
import CatalogsModal from "Components/CatalogsModal";
import FormUsuarios from "Forms/FormUsuarios";
import ConfirmationModal from "Components/ConfirmationModal";
import TabsModal, { TabModalPanel } from "Components/TabsModal";
import GridModal from "Components/GridModal";

import { validateForm, hotToast, uniqueArray } from "utils";
import FormSegmentacion from "Forms/Segmentacion";
import { setParamsSegmentation } from "actions/segmentacion";

const schema = {
  correo: {
    message: "Ingresa el correo",
    pattern: {
      regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
      message: "El correo es valido",
    },
  },
  nombre: { message: "Ingresa el nombre" },
  apellidoPat: { message: "Ingresa el apellido paterno" },
  apellidoMat: { message: "Ingresa el apellido materno" },
  idMarcaOrigen: { message: "Selecciona la marca origen" },
  idEstatus: { message: "Selecciona el estatus inicial" },
};

const Usuarios = () => {
  const [users, setUsers] = React.useState<Array<any>>([]);
  const [profiles, setProfiles] = React.useState<Array<any>>([]);
  const [marcas, setMarcas] = React.useState<Array<any>>([]);
  const [tipoOperacion, setTipoOperaciones] = React.useState<Array<any>>([]);
  const [frmValues, setFrmValues] = React.useState<any>({});
  const [errors, setErrors] = React.useState<any>();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isLoadingGrid, setIsLoadingGrid] = React.useState<boolean>(true);
  const [action, setAction] = React.useState<number>(0);
  const [segmentationValues, setSegmentationValues] = React.useState<any>({});

  const [open, setOpen] = React.useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = React.useState<boolean>(false);
  const [openSegmentation, setOpenSegmentation] =
    React.useState<boolean>(false);
  const { catalogs } = useSelector((state: any) => state.theme);
  const { btnSimple } = useSelector((state: any) => state.theme);
  const { ambiente } = useSelector((state: any) => state.user);

  const [showAlert, setShowAlert] = React.useState<boolean>(false);
  const [selectedTab, setSelectedTab] = React.useState<number>(0);
  const [closed, setClosed] = React.useState<boolean>(false);
  const [pageIndexView, setPageIndexView] = React.useState<number>(0);
  const [pageIndexReport, setPageIndexReport] = React.useState<number>(0);
  const [pageIndexOperationType, setPageIndexOperationType] =
    React.useState<number>(0);

  const [views, setViews] = React.useState<Array<any>>([]);
  const [operaciones, setOperaciones] = React.useState<Array<any>>([]);

  const styles: CSSProperties = {
    fontSize: `clamp(1.6rem, 2.5vw, 2rem)`,
    backgroundColor: catalogs.background,
  };

  React.useEffect(() => {
    handleGetUser();
    getProfiles(0).then((res) => {
      if (res) {
        res = res.filter((perfil: any) => perfil.idEstatus === 1);
        let _profiles = res
          .filter((item: any) => item.visible)
          .map((item: any) => ({
            value: item.idPerfil,
            text: item.descripcion,
          }));
        _profiles = [
          { value: "", text: "Selecciona una opción" },
          ..._profiles,
        ];

        setProfiles(_profiles);
      }
    });

    getBrands(0).then((res) => {
      if (res) {
        let _data = res.map((item: any) => ({
          value: item.idMarca,
          text: `${item.codigoMarca} - ${item.marca}`,
          status: item.idEstatus,
        }));
        _data = [
          { value: "", text: "Selecciona una opción", status: 1 },
          ..._data,
        ];

        setMarcas(_data);
      }
    });

    getDataTabs(null);
  }, []);

  React.useEffect(() => {
    if (frmValues && errors) {
      let _erros: any = { ...errors };
      for (let key in frmValues) {
        if (_erros[key]) {
          delete _erros[key];
        }
      }
      setErrors(_erros);
    }
  }, [frmValues]);

  React.useEffect(() => {
    if (!openConfirm && frmValues.idPerfil !== -1 && frmValues.idUsuario) {
      getDataTabs(frmValues.idPerfil);
    }
  }, [frmValues?.idPerfil]);

  React.useEffect(() => {
    if (!open) {
      setAction(0);
      setSelectedTab(0);
      setFrmValues({});
      setPageIndexView(0);
      setPageIndexReport(0);
      setPageIndexOperationType(0);
      setShowAlert(false);
      setErrors({});
    }
  }, [open]);

  React.useEffect(() => {
    if (frmValues.idMarcaOrigen) {
      getOperationTypesByMarca(frmValues.idMarcaOrigen).then((res) => {
        if (res) {
          let _data = res
            .filter((item: any) => item.idEstatus)
            .map((item: any) => ({
              value: item.idTipoOperacion,
              text: `${item.codigoTipoOperacion} - ${item.tipoOperacion}`,
            }));

          _data = [{ value: "", text: "Selecciona una opción" }, ..._data];
          setTipoOperaciones(_data);
        } else {
          setTipoOperaciones([{ value: "", text: "Selecciona una opción" }]);
        }
      });
    }
  }, [frmValues?.idMarcaOrigen]);

  React.useEffect(() => {
    if (showAlert) {
      hotToast(
        "Hemos detectado que cambio una configuración por lo cual el perfil se elimina del usuario o permisos (vista, reportes , marcas y tipo operaciónes)  se reflejaran al guardar cambios",
        "WAR",
        6500
      );
    }
  }, [showAlert]);

  const getDataTabs = (perfil: number | null) => {
    if (perfil) {
      getByPerfil(perfil).then((res) => {
        setViews(
          res.map((item: any) => {
            return { ...item, saved: true };
          })
        );
      });

      getOperacionFindForPerfilId(perfil).then((res) => {
        setOperaciones(res);
      });
    }
    if (frmValues.idUsuario) {
      getFindUsuarioVista(frmValues.idUsuario).then((res) => {
        setViews(
          res.map((item: any) => {
            return { ...item, saved: true };
          })
        );
      });
      operacionFindByUsuario(frmValues.idUsuario).then((res) => {
        setOperaciones(res);
      });
    }
  };

  const handleGetUser = () => {
    get().then((res) => {
      if (res) {
        setUsers(res);
        setIsLoadingGrid(false);
      }
    });
  };
  const handleSave = async () => {
    let _schema: any = { ...schema };
    if (!frmValues.idUsuario) {
      _schema = {
        ..._schema,
        contrasenia: { message: "Ingresa la contraseña" },
      };
    }
    if (frmValues.idUsuario) {
      _schema = {
        ..._schema,
        idMarcaOrigen: {
          message: "Selecciona la marca origen",
          validate: (value: any) => {
            if (!value) {
              return {
                valid: false,
                message: "Selecciona la marca",
              };
            }
            const _myMarca = marcas.find((item) => item.value === value);
            if (_myMarca && _myMarca.status === 0) {
              return {
                valid: false,
                message: `La marca ${_myMarca.text} esta desactivada`,
              };
            }
            return {
              valid: true,
              message: "",
            };
          },
        },
      };
    }

    let isValid = validateForm({
      schema: _schema,
      values: frmValues,
    });


    if (Object.keys(isValid).length) {
      setErrors({ ...isValid });
      setSelectedTab(0);
      return false;
    }

    let _form = new FormData();
    for (let key in frmValues) {
      if (frmValues[key]) {
        if (frmValues[key]) {
          _form.append(key, frmValues[key]);
        }
      }
    }

    _form.append("ambiente", ambiente);

    if (frmValues.idUsuario) {
      return update(_form).then((res) => {
        return true;
      });
    } else {
      return create(_form).then((res) => {
        if (res) {
          setFrmValues({ ...frmValues, idUsuario: res.id });
        }
        handleGetUser();
        return true;
      });
    }
  };

  const handleSavePermisos = async () => {
    handleSavePermisosOpened(false).then((res) => {
      if (res) {
        handleGetUser();
        setOpen(false);
        setFrmValues({});
        setSelectedTab(0);
      }
    });
  };

  const handleSavePermisosOpened = async (onlyPermissions: boolean) => {
    let _access: Array<any> = [...views].filter(
      (item: any) => item.selected && item.idVistaPadre !== 0 && item.idEstatus
    );

    let subParemtes = views
      .filter((x: any) => x.idEstatus && [2].includes(x.idTipoVista))
      .map((x: any) => {
        let _indexinaccess = _access.filter(
          (a: any) => a.idVistaPadre === x.idVista
        );
        if (_indexinaccess.length > 0) {
          return {
            idVista: x.idVista,
            selected: true,
            idVistaPadre: x.idVistaPadre,
          };
        }
      })
      .filter((item: any) => item);

    let parents: Array<any> = views
      .filter((x: any) => x.idVistaPadre === 0 && x.idEstatus)
      .map((x: any) => {
        let _indexinaccess = [..._access, ...subParemtes].filter(
          (a: any) => a.idVistaPadre === x.idVista
        );
        if (_indexinaccess.length > 0) {
          return {
            idVista: x.idVista,
            selected: true,
          };
        }
      })
      .filter((item: any) => item);
    let _op: Array<any> = [...operaciones].filter((item: any) => item.selected);
    let allPermises = [
      ..._access,
      ...parents,
      ...subParemtes,
      { idVista: 1, selected: true },
    ].map((item: any) => ({ idVista: item.idVista }));

    if (onlyPermissions) {
      return await permissions(frmValues.idUsuario, {
        [frmValues.idPerfil > 0 ? "idPerfil" : ""]:
          frmValues.idPerfil > 0 ? frmValues.idPerfil : null,
        vistas: frmValues.idPerfil > 0 ? [] : uniqueArray(allPermises),
        marcasoperaciones: frmValues.idPerfil > 0 ? [] : uniqueArray(_op),
      }).then((res) => {
        return true;
      });
    } else {
      let isValid: any = await handleSave();
      if (isValid) {
        return await permissions(frmValues.idUsuario, {
          [frmValues.idPerfil > 0 ? "idPerfil" : ""]:
            frmValues.idPerfil > 0 ? frmValues.idPerfil : null,
          vistas: frmValues.idPerfil > 0 ? [] : uniqueArray(allPermises),
          marcasoperaciones: frmValues.idPerfil > 0 ? [] : uniqueArray(_op),
        }).then((res) => {
          return true;
        });
      }
    }
    return false;
  };

  const handleDelete = () => {
    const { idUsuario, idMarcaOrigen, idTipoOperOrigen, idEstatus } = frmValues;
    let _form = new FormData();
    _form.append("idUsuario", idUsuario);
    if (idMarcaOrigen) {
      _form.append("idMarcaOrigen", idMarcaOrigen);
    }
    if (idTipoOperOrigen) {
      _form.append("idTipoOperOrigen", idTipoOperOrigen);
    }
    _form.append("idEstatus", idEstatus ? "false" : "true");
    update(_form).then((res) => {
      setOpenConfirm(false);
      setFrmValues({});
      handleGetUser();
    });
  };

  const handleNext = async () => {
    if (selectedTab === 0 && !frmValues.idUsuario) {
      let _next = await handleSave();
      if (!_next) {
        return false;
      }
    }
    setSelectedTab((current) => {
      if (current + 1 > 3) return 0;
      return current + 1;
    });
  };

  const getMarcas = (data: any) => {
    return marcas.filter((item) => item.status);
  };

  const getOldMarcaText = (idMarca: number) => {
    const selectedMarca = marcas.find(
      (item) => item.value === idMarca && item.status == 0
    );
    if (selectedMarca) return selectedMarca.text;
    return "";
  };

  return (
    <Layout theme={styles}>
      <CatalogsLayout bannerTitle="Usuarios">
        <>
          <Grid
            columns={[
              {
                accessor: "nombre",
                Header: "Nombre",
                Filter: TextFilter,
                filter: "text",
              },
              {
                accessor: "apellidoPat",
                Header: "Apellido Paterno",
                Filter: TextFilter,
                filter: "text",
              },
              {
                accessor: "apellidoMat",
                Header: "Apellido Materno",
                Filter: TextFilter,
                filter: "text",
              },
              {
                accessor: "correo",
                Header: "Correo",
                Filter: TextFilter,
                filter: "text",
              },
              {
                accessor: "tipoOperOrigen",
                Header: "Tipos de Operación",
              },
              {
                accessor: "marcaOrigen",
                Header: "Marca origen",
              },
              {
                accessor: "perfil",
                Header: "Perfil",
              },
            ]}
            data={users}
            config={{
              actions: [
                {
                  action: "view",
                  tooltip: "Detalles",
                  visible: true,
                  color: "#0079ab",
                  icon: "search",
                  handle: (row: any) => {
                    setAction(1);
                    setFrmValues({ ...row });
                    setOpen(true);
                  },
                },
                {
                  action: "edit",
                  tooltip: "Editar",
                  visible: true,
                  handle: (row: any) => {
                    setFrmValues({ ...row });
                    setOpen(true);
                  },
                  color: "#ffb300",
                  icon: "edit",
                  hiddenStatus: true,
                  keyHidden: "idEstatus",
                },
                {
                  action: "status",
                  tooltip: "Estatus",
                  visible: true,
                  handle: (row: any) => {
                    setFrmValues({ ...row });
                    setOpenConfirm(true);
                  },
                  color: "#00a176",
                  icon: "check",
                  isStatus: "idEstatus",
                  colorNegative: "#f15642",
                  iconNegative: "clear",
                },
              ],
            }}
            isLoading={isLoadingGrid}
          >
            <Buttons
              title={"Nuevo usuario"}
              type={"add-catalog"}
              config={btnSimple}
              handleClick={() => {
                setOpen(true);
              }}
            />
          </Grid>
          {open && (
            <TabsModal
              open={open}
              tabs={[
                { id: 0, name: "Usuarios" },
                { id: 1, name: "Vistas" },
                { id: 2, name: "Reportes" },
                { id: 3, name: "Marca y Tipo operaciones" },
              ]}
              selectedTab={selectedTab}
              lastTab={3}
              modalSize={"lg"}
              isLoading={false}
              handleTabChangeClick={(event: any, newTab: any) => {
                if (+newTab > 0) {
                  if (!frmValues.idUsuario) return false;
                }
                setSelectedTab(newTab);
              }}
              handleNextClick={handleNext}
              handleAcceptClick={handleSavePermisos}
              handleCancelClick={() => {
                if (action === 1) {
                  setOpen(false);
                  return;
                }
                setClosed(true);
              }}
              minH={"500px"}
              maxH={"540px"}
              action={action}
            >
              <>
                <TabModalPanel tabId={0} selectedTab={selectedTab}>
                  <FormUsuarios
                    profiles={profiles}
                    marcas={getMarcas(frmValues)}
                    operaciones={tipoOperacion}
                    values={frmValues}
                    setValues={setFrmValues}
                    errors={errors}
                    action={action}
                    textCurrentMarca={getOldMarcaText(
                      frmValues.idMarcaOrigen || 0
                    )}
                  />
                </TabModalPanel>
                <TabModalPanel tabId={1} selectedTab={selectedTab}>
                  <GridModal
                    columns={[
                      {
                        accessor: "vistaPadre",
                        Header: "Vista Padre",
                      },
                      {
                        accessor: "idVista",
                        Header: "Id",
                      },
                      {
                        accessor: "descripcion",
                        Header: "Vista",
                      },
                    ]}
                    data={
                      views
                        ? views.filter(
                          (item: any) =>
                            item.idEstatus &&
                            [0].includes(item.idTipoReporte) &&
                            [2, 3].includes(item.idTipoVista)
                        )
                        : []
                    }
                    config={{
                      actions: [],
                      selects: [
                        {
                          action: "status",
                          Header: "Estatus",
                          valueSelect: "selected",
                          visible: true,
                          accessor: "selected",
                        },
                      ],
                      gridId: "1",
                    }}
                    handleCheckedChange={(input: any) => {
                      if (action === 1) return;
                      if (frmValues.idPerfil !== -1) {
                        const { idPerfil, ...rest } = frmValues;
                        setFrmValues({ ...rest, idPerfil: -1 });
                        setShowAlert(true);
                      }
                      let newState: Array<any> = [...views];
                      let index: number = newState.findIndex(
                        (item: any) => item.idVista === input.idVista
                      );
                      newState[index].selected = !input.selected;
                      newState[index].saved = false;
                      setViews(newState);
                    }}
                    pageStateIndex={pageIndexView}
                    handlePageChange={(e: any) => {
                      setPageIndexView(pageIndexView + e.page);
                    }}
                  />
                </TabModalPanel>
                <TabModalPanel tabId={2} selectedTab={selectedTab}>
                  <GridModal
                    columns={[
                      {
                        accessor: "vistaPadre",
                        Header: "Vista Padre",
                      },
                      {
                        accessor: "idVista",
                        Header: "Id",
                      },
                      {
                        accessor: "descripcion",
                        Header: "Reporte",
                      },
                    ]}
                    data={
                      views
                        ? views.filter(
                          (item: any) =>
                            item.idEstatus &&
                            [1, 2, 3].includes(item.idTipoReporte) &&
                            [4].includes(item.idTipoVista)
                        )
                        : []
                    }
                    config={{
                      actions: [
                        {
                          action: "segmentation",
                          Header: "Segmentación",
                          tooltip: "Segmentación",
                          visible: true,
                          accessorColumn: "selected",
                          handle: (row: any) => {
                            if (!row.saved) {
                              handleSavePermisosOpened(true).then(
                                (res: any) => {
                                  if (res) {
                                    setSegmentationValues({
                                      idUsuario: frmValues.idUsuario,
                                      idVista: row.idVista,
                                      reportName: row.descripcion,
                                    });
                                    setOpenSegmentation(true);
                                  }
                                }
                              );
                            } else {
                              setSegmentationValues({
                                idUsuario: frmValues.idUsuario,
                                idVista: row.idVista,
                                reportName: row.descripcion,
                              });
                              setOpenSegmentation(true);
                            }
                          },
                          color: "transparent",
                          icon: "settings",
                        },
                      ],
                      selects: [
                        {
                          action: "status",
                          Header: "Estatus",
                          valueSelect: "selected",
                          visible: true,
                          accessor: "selected",
                        },
                      ],
                      gridId: "2",
                    }}
                    handleCheckedChange={(input: any) => {
                      if (action === 1) return;

                      if (frmValues.idPerfil !== -1) {
                        const { idPerfil, ...rest } = frmValues;
                        setFrmValues({ ...rest, idPerfil: -1 });
                        setShowAlert(true);
                      }
                      let newState: Array<any> = [...views];
                      let index: number = newState.findIndex(
                        (item: any) => item.idVista === input.idVista
                      );
                      newState[index].selected = !input.selected;
                      newState[index].saved = false;
                      setViews(newState);
                    }}
                    pageStateIndex={pageIndexReport}
                    handlePageChange={(e: any) => {
                      setPageIndexReport(pageIndexReport + e.page);
                    }}
                  />
                </TabModalPanel>
                <TabModalPanel tabId={3} selectedTab={selectedTab}>
                  <GridModal
                    columns={[
                      {
                        accessor: "marca",
                        Header: "Marca",
                      },
                      {
                        accessor: "tipoOperacion",
                        Header: "Tipo Operación",
                      },
                    ]}
                    data={operaciones ? operaciones : []}
                    config={{
                      actions: [],
                      selects: [
                        {
                          action: "status",
                          Header: "Estatus",
                          valueSelect: "selected",
                          visible: true,
                          accessor: "selected",
                        },
                      ],
                      gridId: "3",
                    }}
                    handleCheckedChange={(input: any) => {
                      if (action === 1) return;

                      if (frmValues.idPerfil !== -1) {
                        const { idPerfil, ...rest } = frmValues;
                        setFrmValues({ ...rest, idPerfil: -1 });
                        setShowAlert(true);
                      }
                      let newState: Array<any> = [...operaciones];
                      let index: number = newState.findIndex(
                        (item: any) =>
                          item.idTipoOperacion === input.idTipoOperacion &&
                          item.idMarca === input.idMarca
                      );
                      newState[index].selected = !input.selected;
                      setOperaciones(newState);
                    }}
                    pageStateIndex={pageIndexOperationType}
                    handlePageChange={(e: any) => {
                      setPageIndexOperationType(
                        pageIndexOperationType + e.page
                      );
                    }}
                  />
                </TabModalPanel>
              </>
            </TabsModal>
          )}
          {openSegmentation && (
            <CatalogsModal
              action={"edit"}
              title={"Segmentación de Datos"}
              open={openSegmentation}
              modalSize={"xl"}
              isLoading={isLoading}
              handleAcceptClick={() => {
                setParamsSegmentation(
                  segmentationValues.idUsuario,
                  segmentationValues.idVista,
                  segmentationValues.segmentacionValores
                    ? segmentationValues.segmentacionValores
                    : []
                ).then((res: any) => {
                  setSegmentationValues({});
                  setOpenSegmentation(false);
                });
              }}
              handleCancelClick={() => {
                setSegmentationValues({});
                setOpenSegmentation(false);
              }}
            >
              <FormSegmentacion
                item={segmentationValues}
                action={"edit"}
                errors={errors}
                handleOnChange={(e: any) => {
                  setSegmentationValues({
                    ...segmentationValues,
                    segmentacionValores: e,
                  });
                }}
              />
            </CatalogsModal>
          )}
          {openConfirm && (
            <ConfirmationModal
              open={openConfirm}
              description={`¿Está seguro de ${frmValues.idEstatus ? "desactivar" : "activar"
                } al usuario ${frmValues?.correo}?`}
              modalSize={"sm"}
              isLoading={isLoading}
              handleConfirmClick={handleDelete}
              handleCancelClick={() => {
                setFrmValues({});
                setOpenConfirm(false);
              }}
            ></ConfirmationModal>
          )}

          {closed && (
            <ConfirmationModal
              open={closed}
              description={`Al cerrar la ventana se perderán los cambios que se realizaron sobre el usuario.`}
              modalSize={"sm"}
              isLoading={isLoading}
              handleConfirmClick={() => {
                setClosed(false);
                setOpen(false);
                setSelectedTab(0);
                setFrmValues({});
              }}
              handleCancelClick={() => {
                setClosed(false);
              }}
            ></ConfirmationModal>
          )}
        </>
      </CatalogsLayout>
    </Layout>
  );
};

export default Usuarios;
